module.exports = require("stream-throttle");